const EXPORT_GETTERS = {
  getButtonLoadingState: (state) => state.buttonLoading,
};

export default EXPORT_GETTERS;
